import { Typography, styled } from '@mui/material';

export const StyledButtonText = styled(Typography)`
  font-size: 1.25rem;
`;
